export function ViewIcon({ width = "19", height = "14" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.35002 7.59464C1.23653 7.41494 1.17979 7.32509 1.14802 7.18651C1.12416 7.08241 1.12416 6.91824 1.14802 6.81415C1.17979 6.67556 1.23653 6.58571 1.35002 6.40601C2.28786 4.92103 5.07942 1.16699 9.33359 1.16699C13.5878 1.16699 16.3793 4.92103 17.3172 6.40601C17.4306 6.58571 17.4874 6.67556 17.5192 6.81415C17.543 6.91824 17.543 7.08241 17.5192 7.18651C17.4874 7.32509 17.4306 7.41494 17.3172 7.59464C16.3793 9.07962 13.5878 12.8337 9.33359 12.8337C5.07942 12.8337 2.28786 9.07963 1.35002 7.59464Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33359 9.50033C10.7143 9.50033 11.8336 8.38104 11.8336 7.00033C11.8336 5.61961 10.7143 4.50033 9.33359 4.50033C7.95288 4.50033 6.83359 5.61961 6.83359 7.00033C6.83359 8.38104 7.95288 9.50033 9.33359 9.50033Z"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
